module.exports = __webpack_public_path__ + "img/xx.1d8d04a9.png";